import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import { motion } from "framer-motion";
import { required } from "./Validation";

const spring = {
  type: "spring",
  stiffness: 500,
  damping: 30,
};

const RadioBlock = ({ title, image, value, name, isSelected }) => (
  <label className={`radio-block ${isSelected ? "active" : ""}`}>
    <div className="radio-block__image">
      <img src={image} alt={title} />
      {isSelected && (
        <motion.div
          layoutId="outline"
          className="radio-block__outline"
          initial={false}
          animate={{ borderColor: "#ef4044" }}
          transition={spring}
        />
      )}
    </div>
    <Field
      name={name}
      validate={required("Please select an option")}
      component="input"
      type="radio"
      value={value}
    />{" "}
    {title}
  </label>
);

RadioBlock.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
};

RadioBlock.defaultProps = {
  value: "",
  isSelected: false,
};

export default RadioBlock;
